<template>
  <router-view />
  <default-loading />
  <async-dialog />
</template>

<script setup>
import { startTokenMonitoring } from '@/composables/token-manager'

// 앱 시작 시 토큰 모니터링 시작
let stopTokenMonitoring = null

onMounted(() => {
  stopTokenMonitoring = startTokenMonitoring()
})

onUnmounted(() => {
  if (stopTokenMonitoring) {
    stopTokenMonitoring()
  }
})
</script>
